import React, { useContext, useEffect, useState } from "react";
import Group from "../../assets/images/Group.svg";
import vector from "../../assets/images/Vector.png";
import Vehiclepagecard4 from "../../components/Cards/Vehiclecard4";
import {
  fetchavgkmrunperday,
  fetchlast30Days,
  fetchtcvfleet,
  fetchtdtfleet,
  fetchtotalrunhours,
} from "./Fleetedgekpi";
import { FilterContext } from "../../context/Filter";
import { useQuery } from "@tanstack/react-query";
import Fleettable from "./Fleettable";
import Filteraccordion from "../../components/accordion/Filteraccordian2";
import { TbFilterDown } from "react-icons/tb";
import FleetEdgeFilter from "./FleetEdgeFilter";

const Fleetindex = () => {
  const {
    arn: parArn,
    childArn,
    fleetedgePayload,
    isFilterReady,
  } = useContext(FilterContext);
  const shouldEnableQuery = Boolean(parArn || childArn);
  const [loading, setLoading] = useState(true);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const [data1, setData1] = useState(null);
  const [data2, setData2] = useState(null);
  const [data3, setData3] = useState(null);
  const [data4, setData4] = useState(null);
  const [data5, setData5] = useState(null);

  const handleDropDownChange = () => {
    setIsDropDownOpen((prev) => !prev);
  };

  const refetchAllData = async () => {
    if (!shouldEnableQuery) return;
    setLoading(true);

    // Choose which ARN to send
    const arnToSend = childArn || parArn;

    try {
      const [res1, res2, res3, res4, res5] = await Promise.all([
        fetchavgkmrunperday(arnToSend, fleetedgePayload),
        fetchlast30Days(arnToSend, fleetedgePayload),
        fetchtdtfleet(arnToSend, fleetedgePayload),
        fetchtotalrunhours(arnToSend, fleetedgePayload),
        fetchtcvfleet(arnToSend, fleetedgePayload),
      ]);

      setData1(res1 || {});
      setData2(res2 || {});
      setData3(res3 || {});
      setData4(res4 || {});
      setData5(res5 || {});
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilterReady) return;
    refetchAllData();
  }, [isFilterReady, parArn, childArn, fleetedgePayload]);

  if (!isFilterReady || loading) {
    return (
      <div className="flex justify-center items-center">
        <div className="text-xl font-semibold">
          Loading fuel efficiency data...
        </div>
      </div>
    );
  }
  //   console.log("fleetedgePayload", fleetedgePayload)
  return (
    <div>
      {isDropDownOpen && <FleetEdgeFilter />}
      <div className="flex items-center m-1 text-gray-400 w-full">
        <Vehiclepagecard4
          logo={Group}
          heading={"Total connected Vehicle "}
          value={Number(data5?.result?._shards?.total || 0).toFixed(2)}
        />

        <Vehiclepagecard4
          heading={"Avg KM run/day"}
          value={Number(data1?.result || 0).toFixed(2)}
          logo={Group}
        />

        <Vehiclepagecard4
          heading={"Last 30 days running(KM)"}
          value={Number(data2?.result?.value || 0).toFixed(2)}
          logo={Group}
        />

        <Vehiclepagecard4
          heading={"Total distance travelled"}
          value={Number(data3?.result?.value || 0).toFixed(2)}
          logo={Group}
        />

        <Vehiclepagecard4
          heading={"Total Run Hours"}
          value={Number(data4?.result?.value || 0).toFixed(2)}
          logo={Group}
        />

        <div
          className="bg-[#087FC3] p-2 text-white rounded-md h-10 w-30"
          onClick={handleDropDownChange}
        >
          <TbFilterDown size={24} />
        </div>
      </div>
      <div>
        <Fleettable />
      </div>
    </div>
  );
};

export default Fleetindex;
